import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { MagliveApiClient } from 'src/lib/api-client/maglive-api-client'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { PointPlanRequest } from 'src/lib/entity/manage-point'
import { ToastrService } from 'ngx-toastr'
import { timeValidator } from 'src/app/parts/validation/time-validator'

@Component({
  selector: 'maglive-admin-point-plan-create',
  templateUrl: './point-plan-create.component.html',
  styleUrls: [
    '../../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss',
    './point-plan-create.component.scss',
  ],
})
export class AdminPointPlanCreateComponent implements OnInit {
  // フォーム関係
  formGroup: FormGroup
  isWaiting: boolean

  isShowProductIdInput = false

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    let numPattern = /^[0-9]+$/
    this.formGroup = this.fb.group(
      {
        name: ['', [Validators.required, Validators.maxLength(20)]],
        deviceType: [
          'WEB',
          [Validators.required, Validators.pattern('WEB|IOS|ANDROID')],
        ],
        description: [null, Validators.maxLength(140)],
        amount: [
          '',
          [
            Validators.required,
            Validators.min(50),
            Validators.pattern(numPattern),
            Validators.max(100000000),
          ],
        ],
        storeProductCode: [''],
        paidPoint: [
          '',
          [
            Validators.required,
            Validators.min(1),
            Validators.pattern(numPattern),
            Validators.max(100000000),
          ],
        ],
        freePoint: [
          '',
          [
            Validators.required,
            Validators.min(0),
            Validators.pattern(numPattern),
            Validators.max(100000000),
          ],
        ],
        orderBy: [
          '',
          [
            Validators.required,
            Validators.min(0),
            Validators.pattern(numPattern),
            Validators.max(100000000),
          ],
        ],
        status: ['1', [Validators.required, Validators.pattern('1|2')]],
        startedAt: ['', [Validators.required]],
        endedAt: [''],
      },
      { validators: timeValidator }
    )
  }

  get name() {
    return this.formGroup.get('name')
  }
  get deviceType() {
    return this.formGroup.get('deviceType')
  }
  get description() {
    return this.formGroup.get('description')
  }
  get amount() {
    return this.formGroup.get('amount')
  }
  get storeProductCode() {
    return this.formGroup.get('storeProductCode')
  }
  get paidPoint() {
    return this.formGroup.get('paidPoint')
  }
  get freePoint() {
    return this.formGroup.get('freePoint')
  }
  get orderBy() {
    return this.formGroup.get('orderBy')
  }
  get status() {
    return this.formGroup.get('status')
  }
  get startedAt() {
    return this.formGroup.get('startedAt')
  }
  get endedAt() {
    return this.formGroup.get('endedAt')
  }

  addPointPlan(): void {
    if (this.isWaiting) return

    this.isWaiting = true

    const request: PointPlanRequest = {
      name: this.name.value,
      description: this.description.value,
      amount: Number(this.amount.value),
      storeProductCode:
        this.storeProductCode.value === '' ? null : this.storeProductCode.value,
      deviceType: this.deviceType.value,
      paidPoint: Number(this.paidPoint.value),
      freePoint: Number(this.freePoint.value),
      orderBy: Number(this.orderBy.value),
      startedAt: this.convertUnixTime(this.startedAt.value),
      endedAt: this.endedAt.value
        ? this.convertUnixTime(this.endedAt.value)
        : null,
      status: Number(this.status.value),
    }

    MagliveApiClient.addPointPlan(request).subscribe(
      (response) => {
        if (response === 'NOT_ADMIN') {
          this.toastr.error('管理者以外は登録できません。')
        } else if (response === 'VALIDATION_ERROR') {
          this.toastr.error('入力項目が正しくありません。')
        } else {
          this.toastr.success('登録完了しました。')
          this.router.navigate(['..'], { relativeTo: this.route })
        }
        setTimeout(() => {
          this.isWaiting = false
        }, 3000)
      },
      (error) => {
        console.error(error)
        this.toastr.error('登録に失敗しました。')
        setTimeout(() => {
          this.isWaiting = false
        }, 3000)
      }
    )
  }

  /**
   * OSをWEB以外に選択した場合はプロダクトID入力欄を非表示にする
   */
  onChangeDeviceType(value: string): void {
    if (value === 'WEB') {
      this.isShowProductIdInput = false
      this.storeProductCode.setValidators(null)
    } else if (value === 'IOS') {
      this.isShowProductIdInput = true
      this.storeProductCode.setValidators([
        Validators.required,
        Validators.pattern(/^[0-9a-zA-Z._]*$/),
      ])
    } else {
      this.isShowProductIdInput = true
      this.storeProductCode.setValidators([
        Validators.required,
        Validators.pattern(/^[0-9a-z][0-9a-z_.]*$/),
      ])
    }
    this, this.storeProductCode.updateValueAndValidity()
  }

  /**
   * 文字列で渡された日付をUnixTime(秒単位)に変換する
   */
  private convertUnixTime(datetimeString: string): number {
    let date = new Date(datetimeString)
    return date.getTime() / 1000
  }
}
